/*
  Cassili-home — correctif pagination du configurateur Gallery Wall.
  Chargé AVANT gwb.js.

  Problème : gwb.js appelle /collections/.../products.json?limit=250 une seule fois.
  Shopify plafonne ce endpoint à 250 produits et ignore toute valeur supérieure.
  La collection en compte 449 : les 199 derniers ajoutés n'étaient jamais chargés.

  Ce script intercepte uniquement cette requête précise, enchaîne les pages
  jusqu'à épuisement, et renvoie une réponse unique contenant tout le catalogue.
  Toute autre requête fetch de la page passe sans être touchée.

  Pour retirer le correctif : supprimer la balise <script> correspondante
  dans templates/page.gallery-wall-builder.liquid.
*/
(function () {
  if (typeof window.fetch !== 'function') return;

  var TARGET = 'products.json';
  var PAGE_SIZE = 250;
  var MAX_PAGES = 20;
  var nativeFetch = window.fetch.bind(window);

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';

    var concerne = url.indexOf(TARGET) !== -1
      && url.indexOf('/collections/') !== -1
      && url.indexOf('page=') === -1;

    if (!concerne) return nativeFetch(input, init);

    var base = url.split('?')[0];
    var collected = [];

    function loadPage(page) {
      return nativeFetch(base + '?limit=' + PAGE_SIZE + '&page=' + page, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.json();
        })
        .then(function (data) {
          var batch = (data && data.products) || [];
          collected = collected.concat(batch);
          if (batch.length < PAGE_SIZE || page >= MAX_PAGES) return collected;
          return loadPage(page + 1);
        });
    }

    return loadPage(1).then(function (all) {
      return new Response(JSON.stringify({ products: all }), {
        status: 200,
        headers: { 'Content-Type': 'application/json' }
      });
    });
  };
})();